// One place that knows how to turn a mint into a logo URL.
//
// Shared by useTokenIcon (one mint) and useDripVaultIcons (a registry's worth),
// so the endpoint and the field-name fallbacks are not written twice.

/** Resolves a mint's logo, or undefined when the metadata has none. */
export const fetchTokenIcon = async (mint: string): Promise<string | undefined> => {
  try {
    const response = await fetch(`https://lite-api.jup.ag/tokens/v1/token/${mint}`);
    if (!response.ok) return undefined;
    const data = await response.json();
    const logo: unknown = data?.logoURI ?? data?.logo_uri ?? data?.icon;
    return typeof logo === "string" && logo.length > 0 ? logo : undefined;
  } catch (error) {
    // Non-fatal: consumers fall back to a monogram or to no image.
    console.error("Error fetching token icon:", error);
    return undefined;
  }
};
